export default __webpack_public_path__ + "static/media/camion.6cf13a1b.png";